module.exports = __webpack_public_path__ + "assets/img/user.d363429c.png";